/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

function SEO({ description, lang, meta, title, image }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `keywords`,
          content: `kubernetes, caas, docker, serverless, cloud native, devops, cicd, openstack, google cloud, turnkey, cloud managament, multi cloud, opencloud, aws, azure, alibaba cloud, 阿里雲, 阿里云, tencent cloud, 騰訊雲, 腾讯云, UD cloud, 雲端, 雲端主機, 雲主機, 云端, 云端主机, 云主机, 多重雲端, 多雲端, 多重云端, 多云端, cloud server, 雲端伺服器, 云端伺服器, UD, opencloud, vps, cloud pricing, managed cloud cost, cloud server cost, 雲服務，云服务, google cloud, pccw cloud, 雲伺服器，云伺服器`,
        },
        {
          property: `og:image`,
          content: `${site.siteMetadata.siteUrl}${image}`,
        },
        {
          property: `og:image:width`,
          content: `1200px`,
        },
        {
          property: `og:image:height`,
          content: `630px`,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
